// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2uam5","footer":"ReportModalFilter_footer__3ko5w"};